import { UpdateTransactionDto } from "@common/dto/transactions/update-transaction.dto";
import type { Id } from "react-toastify/unstyled";
import { uuidv7 } from "uuidv7";
import {
    buildInheritedRuleSuggestion,
    InheritedRuleTransactionContext,
} from "./buildInheritedRuleSuggestion";
import { SuggestTransactionRuleToast } from "./SuggestTransactionRuleToast";

export function showInheritedRuleToast({
    payload,
    transaction,
    toast,
}: {
    payload: UpdateTransactionDto;
    transaction: InheritedRuleTransactionContext;
    toast: (content: React.ReactNode, key?: Id) => Id;
}): boolean {
    const suggestion = buildInheritedRuleSuggestion({
        payload,
        transaction,
    });
    if (!suggestion) {
        return false;
    }

    const toastId = uuidv7();
    toast(
        <SuggestTransactionRuleToast
            suggestion={suggestion}
            toastId={toastId}
        />,
        toastId,
    );
    return true;
}
